import React from 'react';
import styled from 'styled-components';

export interface FrameProps {
  title: string | JSX.Element;
  fullWidth?: boolean;
  fullHeight?: boolean;
  hidePrint?: boolean;
  wide?: boolean;
  right?: JSX.Element;
  style?: React.CSSProperties;
  children: JSX.Element | Array<JSX.Element>;
  classes?: string;
}

const TitleBar = styled.div`
  margin-top: 25px;
  font-family: BrandonGrotesque-Regular;
  font-size: 20px;
  letter-spacing: 1.6px;
  color: var(--color-greyish-brown);
  padding-left: 20px;
  padding-top: 7px;
  border-radius: 8px 8px 0px 0px;
  @media print {
    ${(props) => (props.hide ? 'display: none' : '')}
  }
`;

const Top = styled.div`
  ${(props) => (props.full ? 'width: 100%' : '')};
  float: ${(props) => props.float};
`;

const Content = styled.div`
  clear: both;
  padding: 20px;
  @media print {
    background-color: #fff;
    margin-top: 40px;
  }
`;

function Frame(props: FrameProps) {

  const contentStyles = props.fullHeight ? { height: '90vh' } : { marginBottom: '25px' };
  const style: React.CSSProperties = props.fullWidth
    ? ({ width: '100%', backgroundColor: '#ffffff' } as any)
    : {};

  return (
    <div className={props.classes || ''} style={style}>
      <TitleBar hide={props.hidePrint}>
        <Top float="left" full={typeof props.title !== 'string'}>
          {typeof props.title === 'string' ? <b>{props.title}</b> : props.title}
        </Top>
        <Top float="right">{props.right}</Top>
      </TitleBar>
      <Content style={contentStyles}>{props.children}</Content>
    </div>
  );
}

export default Frame;
